import * as React from "react"
import { SwitchSeeker } from "@ui-seeker/core"

import { useAdminBrandForm } from "../../@hooks"


export default function AdminBrandsFormSwitch({ label, field, disabled }) {
    const { value, handleChange } = useAdminBrandForm(field)

    return <SwitchSeeker
        label={label}
        checked={!!value}
		disabled={disabled}
        onChange={e => handleChange(e.target.checked)}
    />
}